// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"LoginControl_mainDiv__SELpf","loadingWra":"LoginControl_loadingWra__1rTsL","videoWrappermy":"LoginControl_videoWrappermy__rYcJJ"};